module.exports = __webpack_public_path__ + "assets/img/bp_d_i_15.90eae31a.jpg";